import { TrendingUp, Search } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const Header = ({ onSearch }) => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [showSearch, setShowSearch] = useState(false);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      onSearch(searchQuery);
    }
  };

  return (
    <header 
      className="sticky top-0 z-50 w-full border-b border-slate-200 bg-white/80 backdrop-blur-xl supports-[backdrop-filter]:bg-white/60"
      data-testid="header"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-4">
        <div className="flex items-center justify-between">
          <button
            onClick={() => {
              navigate("/");
              onSearch("");
            }}
            className="flex items-center gap-3 group"
            data-testid="logo-button"
          >
            <div className="w-10 h-10 rounded-full bg-emerald-900 flex items-center justify-center">
              <TrendingUp className="w-6 h-6 text-white" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-slate-900 group-hover:text-emerald-900 transition-colors">
                FinaNews
              </h2>
              <p className="text-xs font-mono uppercase tracking-widest text-slate-500">
                Finanças Pessoais
              </p>
            </div>
          </button>
          
          <div className="flex items-center gap-4">
            {/* Search */}
            {showSearch ? (
              <form onSubmit={handleSearch} className="flex items-center gap-2">
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Buscar notícias..."
                  className="px-4 py-2 border border-slate-200 rounded-full focus:outline-none focus:ring-2 focus:ring-emerald-900"
                  data-testid="search-input"
                  autoFocus
                />
                <button
                  type="button"
                  onClick={() => setShowSearch(false)}
                  className="text-slate-600 hover:text-slate-900"
                >
                  ×
                </button>
              </form>
            ) : (
              <button
                onClick={() => setShowSearch(true)}
                className="p-2 hover:bg-slate-100 rounded-full transition-colors"
                data-testid="search-button"
              >
                <Search className="w-5 h-5 text-slate-600" />
              </button>
            )}

            <span className="hidden md:block text-sm text-slate-600">
              Atualização diária automática
            </span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;